import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { makeFormField, removeLargeNumbers } from '@/helpers';
import { ui } from '@/constants';
import { OrderApiException, OrderErrorCode } from '@/models';
import { MaxEntreeErrorEvent } from '@/services/analytics/events/max-byoc-error-event';

@Component({
  name: 'CmgMealBuilderMealNameModal',
})
export default class CmgMealBuilderMealNameModal extends Vue {
  readonly maxMealNameLength = 20;
  isSaving = false;
  mealName = makeFormField();
  visibilityWatcher?: () => void;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.mealBuilderMealName.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  validateMealName() {
    if (this.mealName.value.length == 0) {
      this.mealName.error = 'Meal Name Is Required';
    }
    else {
      this.mealName.error = null;
    }
  }

  removeLargeNumbersMealName(){
    this.mealName.value = removeLargeNumbers(this.mealName.value);
  }

  sanitizeMealName(val: string | undefined) {
    return (val || '').trimLeft();
  }

  mounted() {
    this.visibilityWatcher = this.$appStore.watch(
      state => state.ui.modals.mealBuilderMealName.visible,
      (isVisible: boolean) => {
        if (isVisible) {
          const args = this.$appStore.state.ui.modals.mealBuilderMealName.args;
          if (args && args.mealName) {
            this.mealName.value = args.mealName;
          }
        }
      },
    );
  }

  destroyed() {
    if (this.visibilityWatcher) {
      this.visibilityWatcher();
    }
  }

  onCancel() {
    this.forceClose();
  }

  async onSubmit() {
    this.validateMealName();
    if (this.mealName.error || this.isSaving) {
      return;
    }

    const args = this.$appStore.state.ui.modals.mealBuilderMealName.args;

    if (args) {
      this.isSaving = true;

      try {
        await args.beforeClose(this.mealName.value);
      } catch(err) {
        if (err instanceof OrderApiException && err.errors[0].errorCode == OrderErrorCode.MaxEntreeLimitExceeded) {
          this.$services.analytics.send(new MaxEntreeErrorEvent(err.errors[0], args.itemName ?? '', this.$router.currentRoute.name ?? ''));
          this.$services.ui.setModalVisibility('maxEntreeLimitModal', true, { errorMessage: err.errors[0].errorData, errorCode: err.errors[0].errorCode });
        } else {
          throw err;
        }
      } finally {
        this.isSaving = false;
      }
    }

    this.forceClose();
  }

  private forceClose() {
    this.$services.ui.setModalVisibility('mealBuilderMealName', false);
    this.$services.ui.focusBack();
    this.mealName = makeFormField();
    this.mealName.dirty = false;
  }
}
